import { bindRequestLogic } from './utils'
import SectionTypes from '../actionTypes/section'
import { sectionAPI } from '../api'

const getSections = bindRequestLogic({
  clientFunc: sectionAPI.getSections,
  type: SectionTypes.GET_SECTIONS_REQUEST,
  successType: SectionTypes.GET_SECTIONS_SUCCESS,
  failType: SectionTypes.GET_SECTIONS_FAILED,
  isQueryParam: true
})

const addSection = bindRequestLogic({
  clientFunc: sectionAPI.addSection,
  type: SectionTypes.ADD_SECTION_REQUEST,
  successType: SectionTypes.ADD_SECTION_SUCCESS,
  failType: SectionTypes.ADD_SECTION_FAILED
})

const updateSection = bindRequestLogic({
  clientFunc: sectionAPI.updateSection,
  type: SectionTypes.UPDATE_SECTION_REQUEST,
  successType: SectionTypes.UPDATE_SECTION_SUCCESS,
  failType: SectionTypes.UPDATE_SECTION_FAILED
})

const getSection = bindRequestLogic({
  clientFunc: sectionAPI.getSection,
  type: SectionTypes.GET_SECTION_DETAIL_REQUEST,
  successType: SectionTypes.GET_SECTION_DETAIL_SUCCESS,
  failType: SectionTypes.GET_SECTION_DETAIL_FAILED
})

const getComponents = bindRequestLogic({
  clientFunc: sectionAPI.getComponents,
  type: SectionTypes.GET_COMPONENTS_REQUEST,
  successType: SectionTypes.GET_COMPONENTS_SUCCESS,
  failType: SectionTypes.GET_COMPONENTS_FAILED,
  isQueryParam: true
})

const addComponent = bindRequestLogic({
  clientFunc: sectionAPI.addComponent,
  type: SectionTypes.ADD_COMPONENT_REQUEST,
  successType: SectionTypes.ADD_COMPONENT_SUCCESS,
  failType: SectionTypes.ADD_COMPONENT_FAILED
})

const updateComponent = bindRequestLogic({
  clientFunc: sectionAPI.updateComponent,
  type: SectionTypes.UPDATE_COMPONENT_REQUEST,
  successType: SectionTypes.UPDATE_COMPONENT_SUCCESS,
  failType: SectionTypes.UPDATE_COMPONENT_FAILED
})

const updateComponentTranslation = bindRequestLogic({
  clientFunc: sectionAPI.updateComponentTranslation,
  type: SectionTypes.UPDATE_COMPONENT_TRANSLATION_REQUEST,
  successType: SectionTypes.UPDATE_COMPONENT_TRANSLATION_SUCCESS,
  failType: SectionTypes.UPDATE_COMPONENT_TRANSLATION_FAILED
})

export const getSystemSections = bindRequestLogic({
  clientFunc: sectionAPI.getSystemSections,
  type: SectionTypes.GET_SYSTEM_SECTIONS_REQUEST,
  successType: SectionTypes.GET_SYSTEM_SECTIONS_SUCCESS,
  failType: SectionTypes.GET_SYSTEM_SECTIONS_FAILED,
  isQueryParam: true
})

export default [
  getSections,
  addSection,
  updateSection,
  getSection,
  getComponents,
  addComponent,
  updateComponent,
  updateComponentTranslation,
  getSystemSections
]
